/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { UserFragmentFragmentDoc } from './userFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Global_Product_Family_Enum =
  | 'ALL'
  | 'NONE';

export type Product_Family_Name_Enum =
  | 'BEVERAGES'
  | 'FRESH_FOOD'
  | 'GROCERY'
  | 'NON_FOOD_PRODUCTS';

export type Product_Sub_Family_Name_Enum =
  | 'BAKERY'
  | 'BEER_CIDER'
  | 'CLOTHING_TEXTILE'
  | 'DAIRY'
  | 'DELI'
  | 'FISH_SEAFOOD'
  | 'FLORAL'
  | 'FROZEN_FOOD'
  | 'FRUITS'
  /**   */
  | 'GAMES_TOYS'
  | 'HOUSEHOLD_CLEANING'
  | 'HYGIENE_BEAUTY'
  | 'NON_ALCOHOLIC_BEVERAGES'
  | 'PETS'
  | 'RAW_MEAT'
  | 'SALTY_GROCERY'
  | 'SPIRITS'
  | 'SWEET_GROCERY'
  | 'VEGETABLES'
  | 'VEGETARIAN_VEGAN'
  | 'WINE_CHAMPAGNE_SPARKLING';

export type User_Role_Enum =
  | 'BUYER_DIRECTOR'
  | 'BUYER_FINANCE'
  | 'BUYER_MANAGER'
  | 'BUYER_OWNER'
  | 'COMPANY_ADMIN'
  | 'STAFF_ADMIN'
  | 'SUPPLIER_OWNER'
  | 'SUPPLIER_SALES_ADMIN'
  | 'SUPPLIER_SALES_REP';

export type GetCompanyUsersQueryVariables = Exact<{
  companyId: string;
}>;


export type GetCompanyUsersQuery = { role_assignment: Array<{ role_name: Types.User_Role_Enum | null, product_families: Array<{ product_family: Types.Product_Family_Name_Enum | null, product_sub_family: Types.Product_Sub_Family_Name_Enum | null, global_setting: Types.Global_Product_Family_Enum | null }>, user: { email: string, id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } }> };


export const GetCompanyUsersDocument = /*#__PURE__*/ gql`
    query getCompanyUsers($companyId: uuid!) {
  role_assignment(where: {companyId: {_eq: $companyId}}) {
    role_name
    product_families {
      product_family
      product_sub_family
      global_setting
    }
    user {
      ...userFragment
      email
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useGetCompanyUsersQuery__
 *
 * To run a query within a React component, call `useGetCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyUsersQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyUsersQuery, GetCompanyUsersQueryVariables> & ({ variables: GetCompanyUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>(GetCompanyUsersDocument, options);
      }
export function useGetCompanyUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>(GetCompanyUsersDocument, options);
        }
// @ts-ignore
export function useGetCompanyUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>;
export function useGetCompanyUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyUsersQuery | undefined, GetCompanyUsersQueryVariables>;
export function useGetCompanyUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>(GetCompanyUsersDocument, options);
        }
export type GetCompanyUsersQueryHookResult = ReturnType<typeof useGetCompanyUsersQuery>;
export type GetCompanyUsersLazyQueryHookResult = ReturnType<typeof useGetCompanyUsersLazyQuery>;
export type GetCompanyUsersSuspenseQueryHookResult = ReturnType<typeof useGetCompanyUsersSuspenseQuery>;
export type GetCompanyUsersQueryResult = Apollo.QueryResult<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>;